<template>
  <div
    style="
      width: 94% !important;
      margin-left: 3%;
      min-height: 35px;
      line-height: 40px;
    "
  >
    <v-card-text
      class="justified-list pa-0"
      style="display: inline-flex !important; vertical-align: middle"
      :class="isSmallDevice ? 'small-device' : ''"
    >
      <v-col
        class="pa-0 justified-label"
        cols="6"
        style="
          display: inline-flex !important;
          color: black !important;
          vertical-align: middle;
        "
        >{{ labelName }}
      </v-col>
      <v-col
        class="pa-0"
        cols="6"
        style="
          display: inline-grid !important;
          text-align: right;
          color: #757575;
          vertical-align: middle;
        "
        ><div>{{ itemValue && itemValue !== "" ? itemValue : "-" }}</div>
      </v-col>
    </v-card-text>
  </div>
</template>
<script>
import Vue from "vue";

export default Vue.extend({
  props: {
    labelName: String,
    itemValue: String,
    isSmallDevice: Boolean,
  },
});
</script>

<style lang="css" scoped>
.justified-list >>> .v-label {
  right: -1.5rem !important;
  left: auto !important;
  font-size: 0.85rem;
  max-width: 100% !important;
}
.small-device >>> * {
  font-size: 0.8rem !important;
}

.justified-label {
  font-weight: bold;
}
</style>
